// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.amenities.units.RentalManagerUserPropertyUnitAmenityWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyUnitAmenityWebApiHandler_create,
  RentalManagerUserPropertyUnitAmenityWebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { UserPropertyUnitAmenityCreateResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

interface CreateParams {
  availableInSelectUnits?: boolean;
  floorPlanId: string;
  text: string;
}
interface DeleteParams {
  amenityId: string;
}

export interface RentalManagerUserPropertyUnitAmenityWebApiHandler_create_Args {
  getParams: CreateParams;
}

export type RentalManagerUserPropertyUnitAmenityWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyUnitAmenityCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyUnitAmenityWebApiHandler_create_Args
>;

/**
 * Create a free text unit amenity
 * @deprecated
 */
export const useRentalManagerUserPropertyUnitAmenityWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyUnitAmenityWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyUnitAmenityWebApiHandler_create_Args) =>
      RentalManagerUserPropertyUnitAmenityWebApiHandler_create(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyUnitAmenityWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyUnitAmenityWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyUnitAmenityWebApiHandler_delete_Args
>;

/**
 * Delete a free text unit amenity
 * @deprecated
 */
export const useRentalManagerUserPropertyUnitAmenityWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyUnitAmenityWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyUnitAmenityWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyUnitAmenityWebApiHandler_delete(args.getParams, httpClient),
  });
};
